import { envConfig } from "../services/configs/envConfig";

// A ServiceTitan Enterprise Hub host: a per-tenant subdomain of eh.go.servicetitan.com, e.g.
// hickenair.eh.go.servicetitan.com or veteranac-107087.eh.go.servicetitan.com (AB#420).
//
// tblTenant.ehHost is set by hand in the database and ends up in an href, so it is checked
// against this before use. Anchored at both ends: a lookalike that merely CONTAINS the suffix
// (x.eh.go.servicetitan.com.evil.com), a scheme (javascript:), a path or a port is refused.
// tblTenant's chk_tblTenant_ehHost enforces the same pattern at write time; keep the two in step.
const EH_HOST = /^[a-z0-9-]+(\.[a-z0-9-]+)*\.eh\.go\.servicetitan\.com$/i;

// The invoice link(s) for one grid row.
//
// `url` is today's link, unchanged: go.servicetitan.com for ServiceTitan, Workiz's own for a
// Workiz dealer. `ehUrl` is the second link, only for a ServiceTitan tenant with a valid EH host on
// file. Both links exist side by side because branch users of an EH tenant sign in on
// go.servicetitan.com while its hub users sign in on the EH host, so a single per-tenant link would
// break one group or the other. A row with no invoiceId gets no EH link: it would open
// #/EditInvoice/null.
//
// envConfig.EHLinkBase, when set, replaces https://<ehHost>/ -- the same defang every other deep
// link gets from .env.development. The host is still validated, so whether the link appears
// does not depend on it.
export const invoiceUrls = (row, crmSystem) => {
  if (crmSystem === "Workiz") {
    return { url: `${envConfig.WZUrl}${row.invoiceId}`, ehUrl: null };
  }
  const path = `#/EditInvoice/${row.invoiceId}`;
  const hasEhLink = Boolean(row.invoiceId) && EH_HOST.test(row.ehHost ?? "");
  return {
    url: `${envConfig.STUrl}${path}`,
    ehUrl: hasEhLink ? `${envConfig.EHLinkBase || `https://${row.ehHost}/`}${path}` : null,
  };
};

// The text shown for a row's invoice link (AB#420).
//
// `number` is the dealer-searchable number the row carries -- the job number, which
// vwJB360Agreements also exposes as `invoiceNumber`. When it is missing, ServiceTitan rows show a
// dash rather than falling back to invoiceId: that is ServiceTitan's internal id, which dealers
// cannot search for, and showing it as if it were the invoice number sent them looking for a
// number that does not exist. The link stays clickable either way.
//
// Workiz keeps the fallback, because there invoiceId IS the Workiz job UUID the link opens
// (jbwworkizjobsdatasave writes the same UUID to invoiceId and jobNumber).
export const invoiceLabel = (number, invoiceId, crmSystem) => {
  if (number) return number;
  return crmSystem === "Workiz" && invoiceId ? invoiceId : "-";
};
